import React from 'react'
import { useSelector } from 'react-redux'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { selectLocale } from '../../store/navigation/navigation.selectors'
import { searchServiceCtx } from '../../store/search/search.service.constants'
import { withOnlyGE, withOnlyPE } from '../Device'
import { VdeBanner } from '../advertising/VdeBanner'

import { LOCALES } from '../i18n/i18n.constants'

const allowedGeocodeLevels = [
  searchServiceCtx.geocodeLevel.town,
  searchServiceCtx.geocodeLevel.district,
  searchServiceCtx.geocodeLevel.way,
  searchServiceCtx.geocodeLevel.landmark,
  searchServiceCtx.geocodeLevel.namedPlace,
  searchServiceCtx.geocodeLevel.addressRange,
  searchServiceCtx.geocodeLevel.addressPoint,
]

export const shouldDisplayVde = ({ locale, address = {} }) =>
  locale === LOCALES.fr_FR && allowedGeocodeLevels.includes(address.geocode_level)

export const AddressVdeOnMapBanner = withOnlyGE(() => {
  const locale = useSelector(selectLocale)
  const address = useSelector(selectFirstAddress)
  if (shouldDisplayVde({ locale, address })) {
    const { lng, lat } = address.coordinates
    return <VdeBanner key={`ge-${lng}-${lat}`} />
  }
  return <></>
})

export const AddressVdeBanner = withOnlyPE(() => {
  const locale = useSelector(selectLocale)
  const address = useSelector(selectFirstAddress)
  if (shouldDisplayVde({ locale, address })) {
    const { lng, lat } = address.coordinates
    return <VdeBanner key={`pe-${lng}-${lat}`} />
  }
  return <></>
})
